module.exports = __webpack_public_path__ + "static/media/UAKeating.34c0c9ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/karna/UAKeating.jpg
// module id = 391
// module chunks = 0